import styled from "styled-components";
export const ContactFormInternal = styled.div`
  ${({ theme: { breakpoints } }) => breakpoints.desktop} {
    height: 100%;
    width: 100%;
  }
  ${({ theme: { breakpoints } }) => breakpoints.tabletMobile} {
    height: 100%;
    width: 100%;
  }
  top: 0;
  left: 0;
  position: relative;
  margin: 0 auto auto auto;
  transition: transform 0.1s linear, grid-template-rows 0.1s linear;
`;
